<template>
  <div>
    <!-- los autocomplete tienen contemplado el uso de un icon como prepend icon , si desea modificar la propiedad del componente de forma que se cambie el estilo del prepend icon 
    solo hacerloe a traves de este componente para q sea de manera global -->
    <v-autocomplete :dense="dense" class="py-3" v-model="internalValue" :label="textLabel" :items="items" :item-text="itemText"
      :readonly="readonly" :item-value="itemValue" :multiple="multiple" @change="handleChange" :rules="rules"
      :auto-select-first="autoSelectFirst" autocomplete="off" :prepend-icon="icon" :disabled="isDisable" :small-chips="smallChips"
      :return-object="returnObject"></v-autocomplete>
  </div>
</template>
<script>
export default {
  props: {
    isDisable: {
      type: Boolean,
      required: false
    },
    items: {
      type: Array,
      required: true,
    },
    value: {
      validator: (propValue) =>
        propValue === null ||
        typeof propValue === "string" ||
        typeof propValue === "number" ||
        Array.isArray(propValue) ||
        typeof propValue === "object",

      default: null,
      required: true,
    },
    textLabel: {
      type: String,
      default: "",
    },
    icon: String,
    autoSelectFirst: Boolean,
    smallChips: Boolean,
    dense: Boolean,
    multiple: Boolean,
    readonly: Boolean,
    returnObject: Boolean,
    itemText: String,
    itemValue: String,
    rules: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      internalValue: this.value,
    };
  },

  watch: {
    value(newValue) {
      this.internalValue = newValue;
    },
  },

  methods: {
    handleChange() {
      this.$emit("input", this.internalValue);
      this.$emit("change", this.internalValue);
    },
  },
};
</script>
